(function () {
  function log(message, extra) {
    if (typeof console === 'undefined' || typeof console.log !== 'function') return;
    if (extra === undefined) {
      console.log('[MobileRideCritical] ' + message);
      return;
    }
    console.log('[MobileRideCritical] ' + message, extra);
  }

  function joinUrl(base, path) {
    if (!path) return base || '';
    if (!base) return path;
    return String(base).replace(/\/+$/, '') + '/' + String(path).replace(/^\/+/, '');
  }

  function getYmmYearCacheStore() {
    if (typeof window === 'undefined') return {};
    if (!window.__KM_YMM_YEAR_CACHE__) {
      window.__KM_YMM_YEAR_CACHE__ = Object.create(null);
    }
    return window.__KM_YMM_YEAR_CACHE__;
  }

  function uniqueStrings(items) {
    const map = Object.create(null);
    const out = [];
    (items || []).forEach(function (item) {
      const value = String(item || '').trim();
      if (!value) return;
      const key = value.toLowerCase();
      if (map[key]) return;
      map[key] = true;
      out.push(value);
    });
    return out;
  }

  function sortYearsDesc(items) {
    return (items || []).slice().sort(function (a, b) {
      return Number(b) - Number(a);
    });
  }

  function isYearKey(value) {
    return /^[0-9]{4}$/.test(String(value || '').trim());
  }

  function unwrapPayload(payload) {
    if (!payload || typeof payload !== 'object') return payload;
    if (payload.data !== undefined && payload.data !== null) return payload.data;
    return payload;
  }

  function extractPayloadArray(raw) {
    if (Array.isArray(raw)) return raw;
    if (!raw || typeof raw !== 'object') return [];
    const keys = ['list', 'items', 'rows', 'records', 'results', 'values'];
    for (let i = 0; i < keys.length; i += 1) {
      if (Array.isArray(raw[keys[i]])) return raw[keys[i]];
    }
    return [];
  }

  function readStringValue(item, keys) {
    if (typeof item === 'string' || typeof item === 'number') return String(item).trim();
    if (!item || typeof item !== 'object') return '';
    for (let i = 0; i < keys.length; i += 1) {
      const value = item[keys[i]];
      if (value !== undefined && value !== null && String(value).trim()) {
        return String(value).trim();
      }
    }
    return '';
  }

  function normalizeStringList(payload, keys) {
    const source = unwrapPayload(payload);
    let list = extractPayloadArray(source);
    let fromObjectKeys = false;
    if (!list.length && source && typeof source === 'object' && !Array.isArray(source)) {
      list = Object.keys(source);
      fromObjectKeys = true;
    }
    const values = list.map(function (item) {
      if (fromObjectKeys) return String(item || '').trim();
      return readStringValue(item, keys);
    });
    return uniqueStrings(values);
  }

  function fetchJson(url, params) {
    let requestUrl = url || '';
    if (params && typeof params === 'object') {
      const search = new URLSearchParams();
      Object.keys(params).forEach(function (key) {
        const value = params[key];
        if (value === undefined || value === null || value === '') return;
        search.set(key, String(value));
      });
      const query = search.toString();
      if (query) requestUrl += (requestUrl.indexOf('?') === -1 ? '?' : '&') + query;
    }
    return fetch(requestUrl, { credentials: 'include' }).then(function (res) {
      return res.json();
    });
  }

  function setSelectOptions(select, options, placeholder) {
    if (!select || !window.KMSelect) return;
    window.KMSelect.setOptions(select, (options || []).map(function (value) {
      return { value: value, label: value };
    }));
    window.KMSelect.setValue(select, '', placeholder || '', true);
  }

  function setSelectEnabled(select, enabled) {
    if (!select || !window.KMSelect) return;
    window.KMSelect[enabled ? 'enable' : 'disable'](select);
  }

  function setYearLoading(select, loading) {
    if (!select || !window.KMSelect) return;
    select.classList.toggle('is-loading', Boolean(loading));
    select.setAttribute('aria-busy', loading ? 'true' : 'false');
    if (loading) {
      setSelectEnabled(select, false);
      window.KMSelect.setValue(select, '', 'Loading years...', true);
      return;
    }
    if (!getSelectValue(select)) {
      window.KMSelect.setValue(select, '', 'Year', true);
    }
  }

  function getSelectValue(select) {
    if (!select || !window.KMSelect) return '';
    return window.KMSelect.getValue(select) || '';
  }

  function openSheet(root, sheet) {
    if (!root || !sheet) return;
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mobile-ride-sheet-open');
    root.setAttribute('data-mobile-ride-critical-open', 'true');
  }

  function closeSheet(root, sheet) {
    if (!root || !sheet) return;
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mobile-ride-sheet-open');
    root.setAttribute('data-mobile-ride-critical-open', 'false');
  }

  function setup(root) {
    if (!root || root.__kmMobileRideCriticalReady) return;
    const openBtn = root.querySelector('[data-mobile-ride-open]');
    const closeBtns = root.querySelectorAll('[data-mobile-ride-close]');
    const sheet = root.querySelector('[data-mobile-ride-sheet]');
    const yearSelect = root.querySelector('[data-ymm-level="year"]');
    const makeSelect = root.querySelector('[data-ymm-level="make"]');
    const modelSelect = root.querySelector('[data-ymm-level="model"]');
    if (!openBtn || !sheet || !yearSelect || !makeSelect || !modelSelect || !window.KMSelect) return;

    root.__kmMobileRideCriticalReady = true;
    const baseUrl = root.getAttribute('data-garage-base-url') || '';
    const ymmYearUrl = joinUrl(baseUrl, root.getAttribute('data-ymm-year-api') || '/api/vehicle/queryAllYears');
    const ymmMakeUrl = joinUrl(baseUrl, root.getAttribute('data-ymm-make-api') || '/api/vehicle/queryMakes');
    const ymmModelUrl = joinUrl(baseUrl, root.getAttribute('data-ymm-model-api') || '/api/vehicle/queryModels');
    const cacheStore = getYmmYearCacheStore();
    const cacheKey = String(ymmYearUrl || '').trim();
    let cleanupFns = [];
    const makesLoadedByYear = Object.create(null);
    const modelsLoadedByYearMake = Object.create(null);

    function bind(node, eventName, handler, options) {
      node.addEventListener(eventName, handler, options);
      cleanupFns.push(function () {
        node.removeEventListener(eventName, handler, options);
      });
    }

    function fetchYmmYears() {
      const cachedYears = cacheKey && Array.isArray(cacheStore[cacheKey]) ? cacheStore[cacheKey].slice() : null;
      log('YMM years start', { fromCache: Boolean(cachedYears) });
      setYearLoading(yearSelect, true);
      const request = cachedYears
        ? Promise.resolve(cachedYears)
        : fetchJson(ymmYearUrl).then(function (payload) {
            let years = normalizeStringList(payload, ['year', 'name', 'label', 'value']).filter(isYearKey);
            years = sortYearsDesc(years);
            if (cacheKey) cacheStore[cacheKey] = years.slice();
            return years;
          });

      return request.then(function (years) {
        years = sortYearsDesc(years);
          setSelectOptions(yearSelect, years, 'Year');
          setSelectEnabled(yearSelect, years.length > 0);
          setYearLoading(yearSelect, false);
          setSelectOptions(makeSelect, [], 'Make');
          setSelectEnabled(makeSelect, false);
          setSelectOptions(modelSelect, [], 'Model');
          setSelectEnabled(modelSelect, false);
          log('YMM years ready', { years: years.length });
        }).catch(function (error) {
          setYearLoading(yearSelect, false);
          log('YMM years failed', error);
        });
    }

    function fetchMakesForYear(year) {
      const yearValue = String(year || '').trim();
      if (!yearValue) return Promise.resolve([]);
      if (makesLoadedByYear[yearValue]) return Promise.resolve(makesLoadedByYear[yearValue].slice());
      return fetchJson(ymmMakeUrl, { year: yearValue }).then(function (payload) {
        const makes = normalizeStringList(payload, ['make', 'name', 'label', 'value']);
        makesLoadedByYear[yearValue] = makes.slice();
        return makes;
      }).catch(function () {
        return [];
      });
    }

    function fetchModelsForYearMake(year, make) {
      const yearValue = String(year || '').trim();
      const makeValue = String(make || '').trim();
      if (!yearValue || !makeValue) return Promise.resolve([]);
      const key = yearValue + '||' + makeValue.toLowerCase();
      if (modelsLoadedByYearMake[key]) return Promise.resolve(modelsLoadedByYearMake[key].slice());
      return fetchJson(ymmModelUrl, { year: yearValue, make: makeValue }).then(function (payload) {
        const models = normalizeStringList(payload, ['model', 'name', 'label', 'value']);
        modelsLoadedByYearMake[key] = models.slice();
        return models;
      }).catch(function () {
        return [];
      });
    }

    bind(openBtn, 'click', function () {
      openSheet(root, sheet);
    });

    Array.prototype.forEach.call(closeBtns, function (btn) {
      bind(btn, 'click', function () {
        closeSheet(root, sheet);
      });
    });

    bind(yearSelect, 'kmselect:change', function () {
      const year = getSelectValue(yearSelect);
      setSelectOptions(makeSelect, [], 'Make');
      setSelectEnabled(makeSelect, false);
      setSelectOptions(modelSelect, [], 'Model');
      setSelectEnabled(modelSelect, false);
      if (!year) return;
      fetchMakesForYear(year).then(function (makes) {
        if (year !== getSelectValue(yearSelect)) return;
        setSelectOptions(makeSelect, makes, 'Make');
        setSelectEnabled(makeSelect, makes.length > 0);
      });
    });

    bind(makeSelect, 'kmselect:change', function () {
      const year = getSelectValue(yearSelect);
      const make = getSelectValue(makeSelect);
      setSelectOptions(modelSelect, [], 'Model');
      setSelectEnabled(modelSelect, false);
      if (!year || !make) return;
      fetchModelsForYearMake(year, make).then(function (models) {
        if (year !== getSelectValue(yearSelect) || make !== getSelectValue(makeSelect)) return;
        setSelectOptions(modelSelect, models, 'Model');
        setSelectEnabled(modelSelect, models.length > 0);
      });
    });

    root.__kmMobileRideCriticalCleanup = function () {
      cleanupFns.forEach(function (fn) { fn(); });
      cleanupFns = [];
      delete root.__kmMobileRideCriticalCleanup;
    };

    fetchYmmYears();
  }

  function init() {
    if (!window.KMSelect || !window.KMSelect.initAll) {
      log('KMSelect not ready');
      return;
    }
    const roots = document.querySelectorAll('[data-mobile-ride-entry]');
    Array.prototype.forEach.call(roots, setup);
  }

  log('loader start');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
